"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var foundation_1 = require("../../theme/foundation");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core"); // @ts-ignore


var react_paginate_1 = __importDefault(require("react-paginate"));

exports.Pagination = utils_2.forwardRef(function Grid(props, ref) {
  var total = props.total,
      onPageChange = props.onPageChange,
      _a = props.initialPage,
      initialPage = _a === void 0 ? 1 : _a;
  var paginationContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\n\t\t\tul {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tlist-style-type: none;\n\n\t\t\t\tli {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\tbackground: ", ";\n\t\t\t\t\tborder: solid 1px ", ";\n\t\t\t\t\tcolor: ", ";\n\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\tfont-size: 0.875em;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-left: 0.25em;\n\t\t\t\t\tmargin-right: 0.25em;\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&.break {\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tborder-radius: 0;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.pagination__link--active {\n\t\t\t\t\t\tborder: solid 1px transparent;\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tborder-bottom: solid 2px ", ";\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t}\n\n\t\t\t\t\ta {\n\t\t\t\t\t\tpadding: 0.5em 1em;\n\t\t\t\t\t\t&:active {\n\t\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t&:first-of-type {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\n\t\t\tul {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tlist-style-type: none;\n\n\t\t\t\tli {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\tbackground: ", ";\n\t\t\t\t\tborder: solid 1px ", ";\n\t\t\t\t\tcolor: ", ";\n\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\tfont-size: 0.875em;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-left: 0.25em;\n\t\t\t\t\tmargin-right: 0.25em;\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&.break {\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tborder-radius: 0;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.pagination__link--active {\n\t\t\t\t\t\tborder: solid 1px transparent;\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tborder-bottom: solid 2px ", ";\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t}\n\n\t\t\t\t\ta {\n\t\t\t\t\t\tpadding: 0.5em 1em;\n\t\t\t\t\t\t&:active {\n\t\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t&:first-of-type {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"])), foundation_1.colors.white, foundation_1.colors.graphical.strokes, foundation_1.colors.secondary.darkGrey, foundation_1.colors.white, foundation_1.colors.primary.green, foundation_1.colors.primary.green, foundation_1.colors.actions.whiteStateHover);
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: paginationContainer
  }, (0, _core.jsx)(react_paginate_1["default"], {
    previousLabel: 'Previous',
    nextLabel: 'Next',
    pageRangeDisplayed: 1,
    marginPagesDisplayed: 4,
    breakLabels: '...',
    pageCount: total,
    initialPage: initialPage,
    forcePage: initialPage,
    onPageChange: onPageChange,
    containerClassName: 'pagination',
    previousLinkClassName: 'pagination__link',
    nextLinkClassName: 'pagination__link',
    disabledClassName: 'pagination__link--disabled',
    activeClassName: 'pagination__link--active'
  }));
});

if (utils_1.isDev) {
  exports.Pagination.displayName = 'Pagination';
}

var templateObject_1;